import React from 'react'
// Old API
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom'

// New API
// import { createRoot } from 'react-dom/client'

import { datadogRum } from '@datadog/browser-rum'

import NextApp from './NextApp'
import packageJson from '../package.json'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister()
    }
  })
}

const {
  REACT_APP_DATADOG_RUM_ENV,
  REACT_APP_DATADOG_RUM_APP_ID,
  REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
  REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE
} = process.env

if (['dev', 'prd'].includes(REACT_APP_DATADOG_RUM_ENV)) {
  datadogRum.init({
    applicationId: REACT_APP_DATADOG_RUM_APP_ID,
    clientToken: REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'soyshare-web',
    env: REACT_APP_DATADOG_RUM_ENV,
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: REACT_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE || 20,
    trackUserInteractions: true,
    trackViewsManually: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
}

// New API
// const container = document.querySelector('#root')
// const root = createRoot(container)
// root.render(<NextApp />)

/**
 * Old API
 * The old API is used here to maintain compatibility with Antd@3.
 * After upgrading to newer versions of Antd, this will be changed to the new API.
 */
render(<NextApp />, document.getElementById('root'))
